import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';


import { TipoNegoziazione } from '../../../../common/models/tipologiche/tipo-negoziazione';

export class FascicoloNegoziazioneAssistita extends FascicoloFull {

  tipoNegoziazione: TipoNegoziazione;
  dataInvioInvito: number;
  dataRispostaInvito: number;
  dataRicezioneInvito: number;
  dataTermineConcordato: number;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
